import React from "react";
import api from "../../../utility/api/api.js";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap";
import {
  Route,
  BrowserRouter,
  NavLink,
  Switch,
  withRouter,
} from "react-router-dom";
import createHistory from "history/createBrowserHistory";
import {
  actionOrderDetails,
  actionGetReturnReasons,
} from "../../../actions/index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import loader from "../../../images/loader.gif";
const CustomModal = (props) => {
  const { component } = props;

  return (
    <Modal
      isOpen={component.state.lowBalModalVisible}
      backdrop={"static"}
      keyboard={false}
      fade={false}
      toggle={component.toggleLowBalanceModal.bind(component)}
    >
      <ModalHeader className="justify-content-center py-2 alert-secondary">
        Confirm?
      </ModalHeader>
      <ModalBody className="OOSModalBody">
        <div>We will deliver your order</div>
        {/* <div className="select-reason-title">SELECT REASON</div> */}
        {/* {this.props.orderData.order_items.undelivered.map(
                      (obj, key) => this.cellItem(obj, key)
                    )}
                    <div className="text-danger">{this.state.error}</div> */}
      </ModalBody>
      <ModalFooter className="p-0 border-0">
        <div style={{ display: "flex", width: "100%" }}>
          <span className="col-6 text-center">
            <NavLink to="/deliveryorder">
              <button
                className="btn bg-white m-0 py-2"
                onClick={component.toggleLowBalanceModal.bind(component)}
              >
                Cancel
              </button>
            </NavLink>
          </span>
          <span className="col-6 text-center">
            <div
              className=" m-0 py-2 modalbutton"
              exact
              to="/intransit"
              onClick={(e) => component.toggleLowBalanceModal("ok", e)}
            >
              OK
            </div>
          </span>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default CustomModal;



// WEBPACK FOOTER //
// ./src/components/Intransit/DeliverOrder/CustomModal.js